var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "saturation",
      on: {
        mousedown: function($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.selectSaturation($event)
        }
      }
    },
    [
      _c("canvas", { ref: "canvasSaturation" }),
      _vm._v(" "),
      _c("div", { staticClass: "slide", style: _vm.slideSaturationStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }